import React from 'react'
import styled from 'styled-components'
import LanguageSelector from "./LanguageSelector";

const logoPath = process.env.PUBLIC_URL + '/assets/img/logo.svg';

class DesktopNav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  render() {
    return (
      <Nav>
        <div>
          <img className={"logo"} src={logoPath} alt="company logo"/>
            <LanguageSelector />
        </div>
        <ul>
          {this.props.children}
        </ul>
      </Nav>
    )
  }
}

export default DesktopNav

const Nav = styled.nav`
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0));
  width: 100%;
  position: fixed;
  display: flex;
  justify-content: space-between;
  z-index: 10;
  .logo{
    height: 50px;
    margin: 16px;
 }
 ul{
    left: 0;
    padding-top: 26px;
    display: flex;
    list-style: none;
    li{
      margin-left: 16px;
      span{
        font-size:20px ;
        font-weight: 500;
        color:white;
        text-decoration: none;
        text-shadow: 0px 0.5px 0.5px rgba(0, 0, 0, 0.8);
        &:visited{
          color:white;
        }
        &:hover{
          color:white;
          cursor: pointer;
        }
      }
      button{
          color: white;
         font-weight: 600;
         background: rgba(255, 255, 255, 0.1);
         border-left: 1px solid #FFFFFF;
         border-top: 1px solid #FFFFFF;
         border-bottom: 1px solid #FFFFFF;
         padding: 12px;
         margin-top: -6px;
         border-top-left-radius:8px ;
         border-bottom-left-radius:8px ;
         border-right: none;
       &:hover{
        cursor: pointer;
       }
       }
    }
  }

 
`